module.exports = __webpack_public_path__ + "img/seychelles.b1d95c27.svg";